export const SELECT_AN_OPTION = "Select an option";
export const ENTER_A_VALUE = "Enter a value";
